import type { TransitInfo } from '@/types/wedding';

interface Props {
  transit: TransitInfo;
}

export default function TransitBlock({ transit }: Props) {
  const items = [
    { key: 'car', icon: 'ri-car-line', label: '자가용 · 주차', text: transit.car },
    { key: 'bus', icon: 'ri-bus-2-line', label: '버스', text: transit.bus },
    { key: 'subway', icon: 'ri-subway-line', label: '지하철', text: transit.subway },
  ].filter((item) => item.text.trim().length > 0);

  if (items.length === 0) return null;

  return (
    <section className="inv-sec">
      <p className="inv-kicker">Directions</p>
      <div className="inv-transit">
        {items.map((item) => (
          <div className="inv-transit-item" key={item.key}>
            <span className="ti-icon" aria-hidden="true">
              <i className={item.icon} />
            </span>
            <div className="ti-body">
              <span className="ti-label">{item.label}</span>
              <p className="ti-text">{item.text}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}